import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MedicalRecordSportModel} from '../../model/medicalRecordSport.model';
import {MedicalRecordSportSaveFormComponent} from '../medical-record-sport-save-form/medical-record-sport-save-form.component';
import {MedicalSportSaveOneService} from '../../../impl/service/medicalSportSaveOne.service';
import {MedicalSportFindOneService} from '../../../impl/service/medicalSportFindOne .service';
import {IDialogComponent} from '../../../../../../common/dialog/iDialog.component';
import {ConsultationSummaryModel} from '../../../../../consultation/consultation/api/model/consultationSummary.model';
import {DialogWithInput} from '../../../../../../common/dialog/dialogWithInput';
import {BaseView} from '../../../../../../core/view/base.view';
import {
    CreateUpdateDefaultComponent
} from '../../../../../../core/component/create-update-default/create-update-default.component';
import {
    TranscriptionConfig
} from '../../../../../../common/audio/transcription/api/component/audio-transcription/audio-transcription.component';
import {
    AudioTranscriptionConfig
} from "../../../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";
import {
    ConsultationTranscriptionHandler
} from "../../../../../consultation/consultation/api/service/transcription/consultationTranscriptionHandler";


export interface MedicalSportSaveDialogInput {
    id?: number;

    // The 2 following fields are for creation purpose only.
    consultationSummary?: ConsultationSummaryModel;
    partnerId?: number;
    startAudioTranscription?: boolean;
}

export interface MedicalSportSaveDialogResult {
    created: boolean;
    entity: MedicalRecordSportModel;
}

@Component({
    selector: 'app-medical-record-sport-save',
    templateUrl: './medical-record-sport-save.component.html',
    viewProviders: [
        MedicalSportSaveOneService,
        MedicalSportFindOneService,
        ConsultationTranscriptionHandler
    ]
})
export class MedicalRecordSportSaveComponent extends BaseView implements
    IDialogComponent<MedicalSportSaveDialogInput, MedicalSportSaveDialogResult>,
    OnInit {

    dialog: DialogWithInput<MedicalSportSaveDialogInput, MedicalSportSaveDialogResult>;
    entity: MedicalRecordSportModel;
    formGroup: UntypedFormGroup;
    partnerId: number;
    audioTranscription: AudioTranscriptionConfig;

    @ViewChild('createUpdateDefaultComponent') createUpdateDefaultComponent: CreateUpdateDefaultComponent<any, any, any>;
    @ViewChild('form') form: MedicalRecordSportSaveFormComponent;

    constructor(private formBuilder: UntypedFormBuilder,
                public service: MedicalSportSaveOneService,
                public findOneService: MedicalSportFindOneService,
                private transcriptionHandler: ConsultationTranscriptionHandler) {
        super();
        this.formGroup = this.formBuilder.group({});
    }

    ngOnInit() {
        if (!this.dialog.input.id) {
            let context = 'partnerId=' + this.dialog.input.partnerId;
            this.partnerId = this.dialog.input.partnerId;
            if (this.dialog.input.consultationSummary) {
                context += '&consultationId=' + this.dialog.input.consultationSummary.id;
                this.partnerId = this.dialog.input.consultationSummary.partner.id;
            }

            this.transcriptionHandler.setup({
                consultationId: this.dialog.input.consultationSummary?.id,
                partnerId: this.dialog.input.partnerId,
            })
            this.audioTranscription = {
                audioContentValue: 'AUDIO_CONTENT_MEDICAL_CONSULTATION_SPORT',
                context,
                startAutomatically: this.dialog.input.startAudioTranscription,
                enableConversationOption: false,
                showPreview: true,
                handler: this.transcriptionHandler
            };
        }
    }

    entityLoaded(entity: MedicalRecordSportModel) {
        this.entity = entity;

        let context = 'partnerId=' + entity.partner?.id;
        if (entity.consultation) {
            context += '&consultationId=' + entity.consultation?.id;
        }

        this.transcriptionHandler.setup({
            consultationId: entity.consultation?.id,
            partnerId: entity.partner?.id,
        })
        this.audioTranscription = {
            audioContentValue: 'AUDIO_CONTENT_MEDICAL_CONSULTATION_SPORT',
            context,
            startAutomatically: this.dialog.input.startAudioTranscription,
            enableConversationOption: false,
            showPreview: true,
            handler: this.transcriptionHandler
        };
    }

    executeSave() {
        this.createUpdateDefaultComponent.save();
    }

    entitySaved(entity: MedicalRecordSportModel) {
        this.dialog.dialog.close({
            created: !!this.formGroup.get('id').value,
            entity
        });
    }

}
